import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "548.291px",
	height: "548.291px",
	viewBox: "0 0 548.291 548.291",
	style: { enableBackground: "new 0 0 548.291 548.291" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", { d: "M272.148,286.828c-2.754-9.176-5.507-20.642-7.806-29.818h-0.451c-2.292,9.176-4.581,20.874-7.108,29.818l-9.171,32.814 h34.176L272.148,286.828z" }),
			/* @__PURE__ */ _jsx("path", { d: "M486.201,196.121h-13.166v-63.525c0-0.399-0.062-0.795-0.115-1.2c-0.021-2.522-0.825-5-2.552-6.96L364.657,3.675 c-0.033-0.031-0.064-0.042-0.085-0.073c-0.63-0.704-1.364-1.292-2.143-1.796c-0.229-0.157-0.461-0.286-0.702-0.419 c-0.672-0.365-1.387-0.672-2.121-0.893c-0.2-0.052-0.379-0.134-0.577-0.188C358.23,0.118,357.401,0,356.562,0H96.757 C84.894,0,75.256,9.649,75.256,21.502v174.613H62.092c-16.971,0-30.732,13.756-30.732,30.73v159.81 c0,16.966,13.761,30.736,30.732,30.736h13.164V526.79c0,11.854,9.638,21.501,21.501,21.501h354.776 c11.853,0,21.501-9.647,21.501-21.501V417.392h13.166c16.966,0,30.729-13.764,30.729-30.731v-159.81 C516.93,209.877,503.167,196.121,486.201,196.121z M96.757,21.507h249.054v110.006c0,5.94,4.817,10.751,10.751,10.751h94.972 v53.861H96.757V21.507z M336.397,385.492H298.77l-11.942-39.712h-44.278l-10.998,39.712h-36.258l47.256-154.651h45.896 L336.397,385.492z M60.591,310.466c0-52.775,37.623-82.14,84.438-82.14c18.12,0,31.903,3.675,38.092,6.874l-7.108,27.769 c-7.124-2.994-16.981-5.73-29.365-5.73c-27.775,0-49.353,16.733-49.353,51.164c0,30.962,18.368,50.468,49.557,50.468 c10.573,0,22.271-2.288,29.161-5.04l5.268,27.309c-6.417,3.213-20.872,6.641-39.69,6.641 C88.12,387.78,60.591,354.513,60.591,310.466z M451.534,520.968H96.757V417.392h354.776V520.968z M468.111,367.128 c-16.294,13.549-41.076,19.969-71.351,19.969c-18.119,0-30.971-1.155-39.694-2.299V232.917c12.85-2.071,29.595-3.215,47.265-3.215 c29.365,0,48.4,5.268,63.312,16.512c16.069,11.95,26.164,30.987,26.164,58.295C493.807,334.094,483.025,354.513,468.111,367.128z" }),
			/* @__PURE__ */ _jsx("path", { d: "M408,256.547c-7.796,0-12.855,0.692-15.831,1.375v101.175c2.986,0.693,7.806,0.693,12.162,0.693 c31.669,0.23,52.305-17.202,52.305-54.138C456.868,273.521,438.064,256.547,408,256.547z" })
		] }),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {})
	]
});
export default SvgCadIcon;
